// history.js
import { ref, computed } from 'vue'

const historyStack = ref([])

const currentRoute = computed(() => {
  if (historyStack.value.length === 0) return null
  return historyStack.value[historyStack.value.length - 1]
})

const previousRoute = computed(() => {
  if (historyStack.value.length < 2) return null
  return historyStack.value[historyStack.value.length - 2]
})

export function useRouteHistory() {
  return {
    historyStack,
    currentRoute,
    previousRoute,
  }
}
